import { Controller } from "@hotwired/stimulus"

// Creates a private session (room) and goes straight to it with a single Turbo
// visit. This replaces the GET /photo_sessions/new -> 302 redirect flow, which
// on iOS (Hotwire Native) resolves as a double screen push and flashes the room
// page. POST /photo_sessions returns the room path as JSON; we visit it once.
//
// Attach to the trigger element itself, e.g.
//   <button data-controller="private-session" data-action="private-session#start">
export default class extends Controller {
  async start() {
    if (this.element.disabled) return
    this.element.disabled = true

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch("/photo_sessions", {
        method: "POST",
        headers: { "X-CSRF-Token": token, "Accept": "application/json" }
      })
      if (!response.ok) throw new Error(`create failed: ${response.status}`)

      const data = await response.json()
      if (data?.room_path) {
        Turbo.visit(data.room_path, { action: "advance" })
      } else {
        this.element.disabled = false
      }
    } catch (e) {
      this.element.disabled = false
    }
  }
}
